<svg
  routerLink="/home"
   zoomAndPan="magnify"
   viewBox="0 0 226.00715 133.85803"
   height="178.47737"
   preserveAspectRatio="xMidYMid"
   version="1.0"
   id="svg40"
   sodipodi:docname="DIET.svg"
   inkscape:version="1.4 (e7c3feb1, 2024-10-09)"
   xmlns:inkscape="http://www.inkscape.org/namespaces/inkscape"
   xmlns:sodipodi="http://sodipodi.sourceforge.net/DTD/sodipodi-0.dtd"
   xmlns="http://www.w3.org/2000/svg"
   xmlns:svg="http://www.w3.org/2000/svg">
  <defs
     id="defs6">
    <clipPath
       id="193cf4de7f">
      <path
         d="m 194.85156,237.01953 h 71.05078 v 30.72656 h -71.05078 z m 0,0"
         clip-rule="nonzero"
         id="path1" />
    </clipPath>
    <clipPath
       id="e2b09b46ac">
      <path
         d="m 199.35156,237.01953 h 62.04688 c 1.1914,0 2.33593,0.47266 3.17968,1.31641 0.84375,0.84375 1.32032,1.98828 1.32032,3.18359 v 21.72656 c 0,1.19141 -0.47657,2.33594 -1.32032,3.17969 -0.84375,0.84375 -1.98828,1.32031 -3.17968,1.32031 h -62.04688 c -1.19531,0 -2.33984,-0.47656 -3.18359,-1.32031 -0.84375,-0.84375 -1.31641,-1.98828 -1.31641,-3.17969 v -21.72656 c 0,-1.19531 0.47266,-2.33984 1.31641,-3.18359 0.84375,-0.84375 1.98828,-1.31641 3.18359,-1.31641 z m 0,0"
         clip-rule="nonzero"
         id="path2" />
    </clipPath>
    <clipPath
       id="4522899ded">
      <path
         d="M 0.851562,0.0195312 H 71.902344 V 30.746094 H 0.851562 Z m 0,0"
         clip-rule="nonzero"
         id="path3" />
    </clipPath>
    <clipPath
       id="77ddb7522c">
      <path
         d="m 5.351562,0.0195312 h 62.046876 c 1.191406,0 2.335937,0.4726568 3.179687,1.3164068 0.84375,0.84375 1.320313,1.988281 1.320313,3.183593 v 21.726563 c 0,1.191406 -0.476563,2.335937 -1.320313,3.179687 -0.84375,0.84375 -1.988281,1.320313 -3.179687,1.320313 H 5.351562 c -1.195312,0 -2.339843,-0.476563 -3.183593,-1.320313 C 1.324219,28.582031 0.851562,27.4375 0.851562,26.246094 V 4.519531 c 0,-1.195312 0.472657,-2.339843 1.316407,-3.183593 0.84375,-0.84375 1.988281,-1.3164068 3.183593,-1.3164068 z m 0,0"
         clip-rule="nonzero"
         id="path4" />
    </clipPath>
    <clipPath
       id="eb4fcb0ef0">
      <rect
         x="0"
         width="72"
         y="0"
         height="31"
         id="rect4" />
    </clipPath>
    <clipPath
       id="1b31846a2b">
      <path
         d="M 0.160156,23 H 1 v 1 H 0.160156 Z m 0,0"
         clip-rule="nonzero"
         id="path5" />
    </clipPath>
    <clipPath
       id="5b9824f3cc">
      <rect
         x="0"
         width="65"
         y="0"
         height="32"
         id="rect5" />
    </clipPath>
    <clipPath
       id="da76826f4c">
      <rect
         x="0"
         width="317"
         y="0"
         height="375"
         id="rect6" />
    </clipPath>
  </defs>
  <g
     transform="translate(-526.3328,-94.635304)"
     id="g40">
    <g
       clip-path="url(#da76826f4c)"
       id="g39"
       transform="translate(480.379,-39.252759)"
       style="stroke:none">
      <path
         fill="#3a6cac"
         d="m 106.05859,141.92187 c 2.39454,5.21094 2.8086,10.27735 0.48829,15.3086 -3.50782,7.60156 -11.92188,9.22656 -17.945318,3.40625 -5.351562,-5.16406 -6.578124,-11.55078 -4.445312,-18.50781 1.328125,-4.31641 4.289062,-7.32813 8.890625,-8.08594 4.769531,-0.78516 8.371095,1.49219 11.253905,5.07031 0.7461,0.92188 1.26953,2.01563 1.75781,2.80859 z m 0,0"
         fill-opacity="1"
         fill-rule="nonzero"
         id="path6"
         style="stroke:none" />
      <path
         fill="#3a6cac"
         d="m 57.332031,166.87891 c -4.0625,-8.19532 -1.585937,-16.08594 5.363281,-18.11329 6.40625,-1.87109 11.5,0.85547 15.589844,5.5 4.054688,4.59766 5.683594,9.98047 3.203125,15.94141 -1.667969,4 -5.714843,6.28125 -10.261719,5.96875 -6.691406,-0.46094 -11.121093,-4.26172 -13.894531,-9.29687 z m 0,0"
         fill-opacity="1"
         fill-rule="nonzero"
         id="path7"
         style="stroke:none" />
      <path
         fill="#3a6cac"
         d="m 68.960938,184.67578 c 2.929687,5.73047 -0.09375,11.77734 -6.652344,12.9375 -5.804688,1.02734 -10.703125,-0.81641 -14.351563,-5.49219 -3.710937,-4.7539 -2.085937,-11.03125 3.386719,-13.5625 6.117188,-2.82031 14.546875,0.10547 17.617188,6.11719 z m 0,0"
         fill-opacity="1"
         fill-rule="nonzero"
         id="path8"
         style="stroke:none" />
      <path
         fill="#3a6cac"
         d="m 124.625,166.98047 c -4.55469,2.22265 -9.21875,0.58984 -11.39453,-3.98828 -2.92578,-6.16016 0.14844,-14.5586 6.35156,-17.35547 4.51953,-2.03906 9.33203,-0.16016 11.28906,4.41015 2.58985,6.04297 -0.37109,14.0625 -6.24609,16.9336 z m 0,0"
         fill-opacity="1"
         fill-rule="nonzero"
         id="path9"
         style="stroke:none" />
      <path
         fill="#3a6cac"
         d="m 135.76562,179.22266 -9.95703,0.0156 -13.79296,34.60547 -13.843755,-34.55469 -9.839844,0.0195 0.08594,46.35938 9.832031,-0.0195 -0.02344,-12.96485 c -0.0078,-5.07812 -0.07422,-8.96093 -0.644531,-12.40625 l 9.820309,25.35547 9.27735,-0.0195 9.78906,-25.38672 c -0.49609,3.44531 -0.49219,5.63672 -0.47266,15.66016 l 0.0117,9.71484 9.84375,-0.0195 z m 0,0"
         fill-opacity="1"
         fill-rule="nonzero"
         id="path10"
         style="stroke:none" />
      <path
         fill="#3a6cac"
         d="m 165.67578,194.19922 -7.54297,20.12109 -6.86328,-20.08984 -10.33984,0.0156 12.65234,32.36328 -0.5625,1.50391 c -1.24219,3.38672 -2.62109,4.39453 -5.88281,4.39844 l -5.32422,0.008 0.0117,8.08203 c 1.88281,0.5586 4.07812,0.86719 6.39453,0.86719 5.51562,-0.0117 9.01953,-2.71094 11.64062,-9.10547 l 15.84766,-38.1875 z m 0,0"
         fill-opacity="1"
         fill-rule="nonzero"
         id="path11"
         style="stroke:none" />
      <path
         fill="#3a6cac"
         d="m 208.38672,179.08594 -8.60547,23.44922 c -1,2.7539 -1.87109,5.32421 -3.05469,9.77343 -1.01172,-4.00781 -1.89453,-6.88672 -2.96094,-9.76953 l -8.8164,-23.41406 -10.83985,0.0273 17.44141,46.32422 10.46875,-0.0195 16.95313,-46.39062 z m 0,0"
         fill-opacity="1"
         fill-rule="nonzero"
         id="path12"
         style="stroke:none" />
      <path
         fill="#3a6cac"
         d="m 239.27344,214.80078 c -0.6836,2.25781 -3.2461,3.58203 -6.88672,3.58594 -4.25781,0.008 -6.57813,-1.92969 -7.15235,-6.0625 l 22.74219,-0.16797 v -2.44531 c -0.0156,-10.21094 -6.17187,-16.65625 -16.01172,-16.63672 -9.46093,0.0195 -16.03125,6.85937 -16.01172,16.63672 0.0195,9.64453 6.79688,16.52343 16.26172,16.5039 8.58594,-0.0117 14.78125,-4.47656 15.89844,-11.42578 z m -7.22657,-13.89062 c 3.87891,-0.008 6.33204,2.11718 6.33594,5.4375 l -13.03515,0.0234 c 0.74609,-3.76172 2.875,-5.45703 6.69921,-5.46093 z m 0,0"
         fill-opacity="1"
         fill-rule="nonzero"
         id="path13"
         style="stroke:none" />
      <path
         fill="#3a6cac"
         d="m 271.96094,202.02734 -0.0195,-8.01953 -5.95313,0.0117 -0.0195,-9.71484 -9.64844,0.0156 0.0195,9.71094 -5.95312,0.0117 0.0195,8.01953 5.94531,-0.0117 0.043,23.30469 9.65625,-0.0156 -0.043,-23.30859 z m 0,0"
         fill-opacity="1"
         fill-rule="nonzero"
         id="path14"
         style="stroke:none" />
      <g
         clip-path="url(#193cf4de7f)"
         id="g20"
         style="stroke:none">
        <g
           clip-path="url(#e2b09b46ac)"
           id="g19"
           style="stroke:none">
          <g
             transform="translate(194,237)"
             id="g18"
             style="stroke:none">
            <g
               clip-path="url(#eb4fcb0ef0)"
               id="g17"
               style="stroke:none">
              <g
                 clip-path="url(#4522899ded)"
                 id="g16"
                 style="stroke:none">
                <g
                   clip-path="url(#77ddb7522c)"
                   id="g15"
                   style="stroke:none">
                  <path
                     fill="#f47800"
                     d="M 0.851562,0.0195312 H 71.902344 V 30.746094 H 0.851562 Z m 0,0"
                     fill-opacity="1"
                     fill-rule="nonzero"
                     id="path15"
                     style="stroke:none" />
                </g>
              </g>
            </g>
          </g>
        </g>
      </g>
      <g
         transform="translate(195,239)"
         id="g38"
         style="stroke:none">
        <g
           clip-path="url(#5b9824f3cc)"
           id="g37"
           style="stroke:none">
          <g
             clip-path="url(#1b31846a2b)"
             id="g24"
             style="stroke:none">
            <g
               fill="#ffffff"
               fill-opacity="1"
               id="g23"
               style="stroke:none">
              <g
                 transform="translate(0.948119,23.123655)"
                 id="g22"
                 style="stroke:none">
                <g
                   id="g21"
                   style="stroke:none" />
              </g>
            </g>
          </g>
          <g
             fill="#ffffff"
             fill-opacity="1"
             id="g27"
             style="stroke:none">
            <g
               transform="translate(7.780593,23.123655)"
               id="g26"
               style="stroke:none">
              <g
                 id="g25"
                 style="stroke:none">
                <path
                   d="m 1.5,-20.65625 h 5.984375 c 2.875,0 5.328125,0.984375 7.359375,2.953125 2.03125,1.960937 3.046875,4.414063 3.046875,7.359375 0,2.980469 -1.015625,5.449219 -3.046875,7.40625 C 12.820312,-0.976562 10.367188,0 7.484375,0 H 1.5 Z M 6.203125,-4.203125 H 6.9375 c 1.71875,0 3.125,-0.578125 4.21875,-1.734375 1.09375,-1.164062 1.644531,-2.625 1.65625,-4.375 0,-1.75 -0.546875,-3.207031 -1.640625,-4.375 -1.09375,-1.175781 -2.507813,-1.765625 -4.234375,-1.765625 H 6.203125 Z m 0,0"
                   id="path24"
                   style="stroke:none" />
              </g>
            </g>
          </g>
          <g
             fill="#ffffff"
             fill-opacity="1"
             id="g30"
             style="stroke:none">
            <g
               transform="translate(26.250577,23.123655)"
               id="g29"
               style="stroke:none">
              <g
                 id="g28"
                 style="stroke:none">
                <path
                   d="M 6.203125,-20.65625 V 0 H 1.5 v -20.65625 z m 0,0"
                   id="path27"
                   style="stroke:none" />
              </g>
            </g>
          </g>
          <g
             fill="#ffffff"
             fill-opacity="1"
             id="g33"
             style="stroke:none">
            <g
               transform="translate(33.958914,23.123655)"
               id="g32"
               style="stroke:none">
              <g
                 id="g31"
                 style="stroke:none">
                <path
                   d="m 13.3125,-20.65625 v 4.140625 H 6.203125 v 4.09375 h 6.8125 v 4.140625 h -6.8125 V -4.125 H 13.3125 V 0 H 1.5 v -20.65625 z m 0,0"
                   id="path30"
                   style="stroke:none" />
              </g>
            </g>
          </g>
          <g
             fill="#ffffff"
             fill-opacity="1"
             id="g36"
             style="stroke:none">
            <g
               transform="translate(48.474629,23.123655)"
               id="g35"
               style="stroke:none">
              <g
                 id="g34"
                 style="stroke:none">
                <path
                   d="M 0.203125,-16.515625 V -20.65625 H 14.71875 v 4.140625 H 9.8125 V 0 H 5.109375 v -16.515625 z m 0,0"
                   id="path33"
                   style="stroke:none" />
              </g>
            </g>
          </g>
        </g>
      </g>
    </g>
  </g>
</svg>



